/**
 * deployment-summary-view.js
 */

import React from 'react';
import {
  Typography,
} from '@mui/material';
import {
  useParams,
} from "react-router-dom";
import { Types } from 'utils/constants';
import useRecordStore from 'contexts/record-store';
import IconSection from 'components/icon-section';
import WeatherView from 'components/weather/view';
import FilesView from 'components/files/view/files-view';


export default function DeploymentSummaryView(props) {
  const { deploymentId } = useParams();
  const recordStore = useRecordStore();
  const deploymentRecord = recordStore.useRecord(Types.Record.DEPLOYMENT, deploymentId).ornull;


  return (
    <>
      {deploymentRecord &&
      <>

        {/* detection comments */}
        <IconSection iconName='comment'>
          <Typography variant="body2" style={{ whiteSpace: 'pre-wrap' }}>
            {deploymentRecord.get().summary.comments}
          </Typography>
        </IconSection>

        {/* weather */}
        <WeatherView weather={deploymentRecord.get().summary.weather} />

        {/* files */}
        <FilesView files={deploymentRecord.get().summary.files} />

      </>}
    </>
  );
}